<div class="flex flex-col gap-4" data-cy="medical-attachments">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <h3 class="medical-section-title text-lg font-semibold m-0">{{ 'animalMedical.sections.attachments' | transloco }}</h3>
    <div class="flex flex-wrap items-center gap-2">
      <span class="relative block w-72">
        <i class="pi pi-search absolute top-1/2 left-3 -translate-y-1/2 text-gray-400 pointer-events-none"></i>
        <input
          pInputText
          type="text"
          class="w-full pl-9"
          [placeholder]="'animalMedical.attachments.search' | transloco"
          [(ngModel)]="search"
        />
      </span>
      <p-select
        [options]="sortOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="sortOrder"
        styleClass="w-48"
      >
        <ng-template pTemplate="item" let-option>{{ option.label | transloco }}</ng-template>
        <ng-template pTemplate="selectedItem" let-option>{{ option?.label | transloco }}</ng-template>
      </p-select>
    </div>
  </div>

  <div class="flex flex-wrap gap-2">
    @for (category of categories; track category) {
      <p-button
        size="small"
        [rounded]="true"
        [outlined]="categoryFilter !== category"
        [disabled]="!countFor(category)"
        [label]="(categoryLabelKey(category) | transloco) + ' (' + countFor(category) + ')'"
        (onClick)="toggleCategory(category)"
      />
    }
  </div>

  @if (!files.length) {
    <p-message severity="info">{{ 'animalMedical.attachments.empty' | transloco }}</p-message>
  } @else if (!visibleFiles.length) {
    <p-message severity="info">{{ 'animalMedical.attachments.emptyFiltered' | transloco }}</p-message>
  }

  <div class="grid gap-3 grid-cols-[repeat(auto-fill,minmax(14rem,1fr))]">
    @for (file of visibleFiles; track file.key) {
      <article class="border border-gray-200 rounded-lg overflow-hidden flex flex-col">
        <button type="button" class="relative h-32 bg-gray-100 flex items-center justify-center cursor-pointer"
                [attr.aria-label]="file.name" (click)="openFile.emit(file)">
          @if (file.kind === 'image') {
            <app-animal-image-container [id]="file.id" [variant]="'app-preview'" class="w-full h-full" />
          } @else {
            <i [class]="fileIcon(file) + ' text-5xl'"></i>
          }
        </button>
        <div class="p-2 flex flex-col gap-1 text-sm">
          <span class="font-medium truncate" [title]="file.name">{{ file.name }}</span>
          <span class="text-xs text-gray-500">
            {{ categoryLabelKey(file.category) | transloco }}
            @if (file.size !== null) { · {{ file.size | fileSize }} }
            @if (file.date) { · {{ file.date | date:'dd.MM.yyyy' }} }
          </span>
          <a class="text-xs cursor-pointer text-[var(--p-primary-700)] hover:underline self-start" (click)="goToRecord.emit(file.recordId)">
            {{ 'animalMedical.recordLink' | transloco: { id: file.recordId } }}
          </a>
        </div>
      </article>
    }
  </div>
</div>
